<template>
  <div v-if="employee">
    <div class="text-xs-right">
      <v-btn :loading="loading" flat fab small class="extra-small" @click="cancelEmployee">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-layout wrap>
      <v-flex xs12 :sm6="type == 'add'" class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('empIdInput') }">
          <div class="caption">Emp ID</div>
          <input
            type="text"
            v-model="employee.emp_id"
            data-vv-name="empIdInput"
            data-vv-as="Emp ID"
            v-validate="`required|length:5|excluded:${excludedID ? ',' + excludedID : ''}`"
          />
          <span class="text-error" v-show="errors.has('empIdInput')">{{
            errors.first('empIdInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1" v-if="type == 'add'">
        <div class="form-control" :class="{ 'has-error': errors.has('passwordInput') }">
          <div class="caption">Password</div>
          <input
            type="text"
            data-vv-name="passwordInput"
            data-vv-as="Password"
            v-model="employee.password"
            v-validate="'required'"
          />
          <span class="text-error" v-show="errors.has('passwordInput')">{{
            errors.first('passwordInput')
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <div class="form-control pa-1" :class="{ 'has-error': errors.has('statusInput') }">
      <div class="caption">Status</div>
      <multiselect
        v-model="employee.emp_status"
        :options="statusOptions"
        selectLabel
        selectedLabel
        :allow-empty="false"
        :searchable="false"
        deselect-label
        class="mb-2"
        v-validate="'required'"
        data-vv-name="statusInput"
        data-vv-as="Status"
      ></multiselect>
      <span class="text-error" v-show="errors.has('statusInput')">{{
        errors.first('statusInput')
      }}</span>
    </div>
    <v-layout wrap>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('firstnameInput') }">
          <div class="caption">First Name</div>
          <input
            type="text"
            v-model="employee.emp_first_name"
            maxlength="255"
            v-validate="'required'"
            data-vv-name="firstnameInput"
            data-vv-as="First Name"
          />
          <span class="text-error" v-show="errors.has('firstnameInput')">{{
            errors.first('firstnameInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('lastnameInput') }">
          <div class="caption">Last Name</div>
          <input
            type="text"
            v-model="employee.emp_last_name"
            maxlength="255"
            v-validate="'required'"
            data-vv-name="lastnameInput"
            data-vv-as="Lastname"
          />
          <span class="text-error" v-show="errors.has('lastnameInput')">{{
            errors.first('lastnameInput')
          }}</span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('divisionInput') }">
          <div class="caption">Division</div>
          <input
            type="text"
            v-model="employee.division"
            maxlength="255"
            v-validate="'required'"
            data-vv-name="divisionInput"
            data-vv-as="Division"
          />
          <span class="text-error" v-show="errors.has('divisionInput')">{{
            errors.first('divisionInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('departmentInput') }">
          <div class="caption">Department</div>
          <input
            type="text"
            v-model="employee.department"
            maxlength="255"
            v-validate="'required'"
            data-vv-name="departmentInput"
            data-vv-as="Department"
          />
          <span class="text-error" v-show="errors.has('departmentInput')">{{
            errors.first('departmentInput')
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('positionNameInput') }">
          <div class="caption">Position Name</div>
          <input
            type="text"
            v-model="employee.position_name"
            maxlength="255"
            v-validate="'required'"
            data-vv-name="positionNameInput"
            data-vv-as="Position Name"
          />
          <span class="text-error" v-show="errors.has('positionNameInput')">{{
            errors.first('positionNameInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('levelInput') }">
          <div class="caption">Level</div>
          <multiselect
            v-model="employee.position_level"
            :options="levelOptions"
            selectLabel
            selectedLabel
            :allow-empty="false"
            :searchable="false"
            deselect-label
            class="mb-2"
            v-validate="'required'"
            data-vv-name="levelInput"
            data-vv-as="Level"
          ></multiselect>
          <span class="text-error" v-show="errors.has('levelInput')">{{
            errors.first('levelInput')
          }}</span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 sm4 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('leaveBalanceInput') }">
          <div class="caption">Leave Balance</div>
          <input
            type="text"
            v-model="employee.leave_balance"
            maxlength="255"
            v-validate="'required|decimal'"
            data-vv-name="leaveBalanceInput"
            data-vv-as="Leave Balance"
          />
          <span class="text-error" v-show="errors.has('leaveBalanceInput')">{{
            errors.first('leaveBalanceInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('startPointInput') }">
          <div class="caption">Start Point</div>
          <input
            type="text"
            v-model="employee.start_point"
            maxlength="255"
            v-validate="'required|decimal'"
            data-vv-name="startPointInput"
            data-vv-as="Start Point"
          />
          <span class="text-error" v-show="errors.has('startPointInput')">{{
            errors.first('startPointInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('additionalPointInput') }">
          <div class="caption">Additional Point</div>
          <input
            type="text"
            v-model="employee.additional_point"
            maxlength="255"
            v-validate="'required|decimal'"
            data-vv-name="additionalPointInput"
            data-vv-as="Additional Point"
          />
          <span class="text-error" v-show="errors.has('additionalPointInput')">{{
            errors.first('additionalPointInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('pointBalanceInput') }">
          <div class="caption">Point Balance</div>
          <input
            type="text"
            v-model="employee.point_balance"
            maxlength="255"
            v-validate="'required|decimal'"
            data-vv-name="pointBalanceInput"
            data-vv-as="Point Balance"
          />
          <span class="text-error" v-show="errors.has('pointBalanceInput')">{{
            errors.first('pointBalanceInput')
          }}</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1">
        <div class="form-control" :class="{ 'has-error': errors.has('redeemPointInput') }">
          <div class="caption">Redeem Point</div>
          <input
            type="text"
            v-model="employee.redeem_point"
            maxlength="255"
            v-validate="'required|decimal'"
            data-vv-name="redeemPointInput"
            data-vv-as="Redeem Point"
          />
          <span class="text-error" v-show="errors.has('redeemPointInput')">{{
            errors.first('redeemPointInput')
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <div class="text-xs-center">
      <v-btn :loading="loading" color="grey" outline @click="cancelEmployee">{{
        $t('cancel')
      }}</v-btn>
      <v-btn :loading="loading" color="primary" depressed @click="saveEmployee">{{
        $t('Save')
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
export default {
  props: ['value', 'type', 'exceptid'],
  data() {
    return {
      employee: null,
      statusOptions: ['Active', 'Resign'],
      levelOptions: ['Executive', 'Management', 'Manager', 'Supervisor', 'Officer', 'Operation'],
      excludedID: '',
      loading: false
    }
  },
  mounted() {
    var vm = this
    if (this.value) {
      this.employee = this.value
      this.cached_employee = JSON.stringify(this.value)
    } else {
      this.reset()
    }

    var empids = vm.exceptid.split(',')

    if (vm.employee && vm.type === 'edit' && vm.exceptid && vm.exceptid !== '') {
      $.each(empids, function (index, id) {
        if (vm.employee && id === vm.employee.emp_id) {
          empids.splice(index, 1)
          return false
        }
      })

      vm.excludedID = empids.join(',')
    } else {
      vm.excludedID = empids.join(',')
    }
  },
  components: {
    Multiselect
  },
  methods: {
    reset() {
      this.employee = {
        emp_id: '',
        password: '',
        emp_status: '',
        emp_first_name: '',
        emp_last_name: '',
        division: '',
        department: '',
        position_name: '',
        position_level: '',
        leave_balance: '',
        start_point: '',
        additional_point: '',
        point_balance: '',
        redeem_point: ''
      }
      this.cached_employee = JSON.stringify(this.employee)
    },
    saveEmployee: function () {
      var vm = this
      var data = this.employee
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          reject()
          return false
        }
        vm.loading = true

        if (vm.type == 'add') {
          api.saveHafeleUsername(data, function (error, response) {
            if (error) {
              console.error(error)
              vm.loading = false
              return
            }
            vm.$emit('onSaveEmpolyee', vm.employee)
            vm.reset()
            vm.loading = false
          })
        } else {
          delete data['password']
          api.updateHafeleUsername(data, function (error, response) {
            if (error) {
              console.error(error)
              vm.loading = false
              return
            }
            vm.cached_employee = JSON.stringify(vm.employee)
            vm.$emit('onSaveEmpolyee', vm.employee)
            vm.loading = false
          })
        }
      })
    },
    cancelEmployee: function () {
      var vm = this
      if (vm.type == 'add') {
        vm.reset()
      } else {
        vm.employee = JSON.parse(vm.cached_employee)
      }
      vm.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/hafele/HafeleCustomerManage.vue